import React, {useState} from 'react';
import {PlusOutlined, DeleteOutlined, SaveOutlined} from "@ant-design/icons";
import $ from 'jquery'
function Manbalar() {
    const [manbalar, setManbalar] = useState(localStorage.getItem('sfr-hm-manbalar') ? JSON.parse(localStorage.getItem('sfr-hm-manbalar')) : [])
    const istemolchilar = localStorage.getItem('sfr-hm-istemolchilar') ? JSON.parse(localStorage.getItem('sfr-hm-istemolchilar')) : []
    const sanoat = localStorage.getItem('sfr-hm-ste') ? JSON.parse(localStorage.getItem('sfr-hm-ste')) : []
    const [forDelete, setForDelete] = useState()
    const checkedHandler = (e, i) => {
        setForDelete(e)
        if (e) {
            $("input[type=checkbox]").each(function () {
                if ($(this)[0].className != 'checkbox' + i) {
                    $(this)[0].checked = false
                }
            })
            setForDelete(i)
        } else {
            setForDelete()
        }
    }
    const changeValueHandler = (v, i, c) => {
        let m = [...manbalar]
        m[i][c] = v
        setManbalar(m)
    }
    const addHandler = () => {
        var id = 0;
        if (manbalar.length) {
            for (var i = 0; i < manbalar.length; i++) {
                if (id < manbalar[i].id) {
                    id = manbalar[i].id
                }
            }
        }
        let m = [...manbalar]
        m.push({id: id + 1, name: "Yangi manba", fik: 1})
        setManbalar(m)
    }
    const deleteHandler = () => {
        const ist = istemolchilar.filter(p => p.mid == forDelete)[0]
        const ste = sanoat.filter(p => p.manba == forDelete)[0]
        if (ist || ste) {
            alert("Avval ushbu manbaga biriktirilgan istemolchi(lar)ni o'chiring!")
            return false
        }
        let m = manbalar.filter(p => p.id !== forDelete)
        setManbalar(m)
        setForDelete()
        $("input[type=checkbox]").each(function () {
            $(this)[0].checked = false
        })
    }
    return (
        <div className="row">
            <div className="col-12">
                <h3 className="my-4 text-center">Suv manbalari</h3>
            </div>
            <div className="col-12">
                <div className="row">
                    <div className="col-7">
                        <div className="flextableblock">
                            <table className="table table-bordered change_gidromodule_table">
                                <thead>
                                <tr>
                                    <th>o</th>
                                    <th>T/r</th>
                                    <th>Suv manbalari</th>
                                    <th>FIK</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    manbalar.length ?
                                        manbalar.map((m, i) => {
                                            return <tr key={i}>
                                                <td><input type="checkbox" className={"checkbox" + m.id}
                                                           onChange={e => checkedHandler(e.target.checked, m.id)}/>
                                                </td>
                                                <td>{i + 1}</td>
                                                <td className="inptd">
                                                    <input type="text" className="inputable" value={m.name}
                                                           onChange={e => changeValueHandler(e.target.value, i, 'name')}/>
                                                </td>
                                                <td className="inptd" style={{maxWidth: "50px"}}>
                                                    <input type="number" className="inputable" value={m.fik}
                                                           onChange={e => changeValueHandler(e.target.value, i, 'fik')}/>
                                                </td>
                                            </tr>
                                        })
                                        : null
                                }
                                </tbody>
                            </table>
                        </div>
                        <p>Suv manbasi nomini va FIKni tablitsaga bosish orqali o'zgartirish mumkin</p>
                    </div>
                    <div className="col-3 offset-1 d-flex flex-column justify-content-between pb-5">
                        <div>
                            <div className="my-4">
                                <button className="btn btn-sm btn-outline-primary d-flex align-items-center"
                                        onClick={() => addHandler()}>Yangi suv manbasi&nbsp;&nbsp;<PlusOutlined/>
                                </button>
                            </div>
                            <div className="my-4">
                                <button disabled={!forDelete}
                                        className="btn btn-sm btn-outline-danger d-flex align-items-center"
                                        onClick={() => deleteHandler()}>Manbani o'chirish&nbsp;&nbsp;
                                    <DeleteOutlined/></button>
                            </div>
                        </div>
                        <div>
                            <button className="btn btn-sm btn-outline-success d-flex align-items-center" onClick={() => {
                                localStorage.setItem('sfr-hm-manbalar', JSON.stringify(manbalar))
                                window.location = '/sfr/gidromodul/new/insert/istemolchilar'
                            }}>
                                Manbalarni saqlash&nbsp;&nbsp;<SaveOutlined/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Manbalar;